<div class="header">
    <div class="box">?</div>
    <h1>{{'achievement.my_profile_pop_up_header' | translate}}</h1>
</div>
<div class="body">{{'achievement.my_profile_pop_up_body' | translate}}</div>
<button (click)="dismiss($event)">{{'achievement.my_profile_pop_up_action' | translate}}</button>